import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container, TilingSprite } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { useCallback, useMemo } from 'react';
import { BACKGROUND_VIGNETTE_IMAGE_URL } from '../../../../assets/themeBackgroundAssetUrls';
import { isConfigFlagEnabled } from '../../../../config';
import { selectIsAnimatedRoomBackgroundsOn } from '../../../../redux/reducers/selfDataReducer';
import { useAppSelector } from '../../../../redux/store';
import { ALL_THEME_BACKGROUND_PROPERTIES } from '../../../../types/themeBackgroundTypes';
import { assertUnreachable } from '../../../../utils/tsUtils';
import { isTestEnvironment } from '../../../../utils/utils';
import { CoveringSprite } from '../../pixiComponents/coveringSprite';
import { PokerRoomAnimatedBackground } from './pokerRoomAnimatedBackground';
export const PokerRoomBackground = () => {
    const stageDimensionsW = useAppSelector((state) => state.gameDimensions.stageDimensions?.w);
    const stageDimensionsH = useAppSelector((state) => state.gameDimensions.stageDimensions?.h);
    const themeBackgroundType = useAppSelector((state) => state.theme.themeBackground?.type);
    const isAnimatedRoomBackgroundsOn = useAppSelector(selectIsAnimatedRoomBackgroundsOn);
    const texture = useMemo(() => themeBackgroundType
        ? PIXI.Texture.from(ALL_THEME_BACKGROUND_PROPERTIES[themeBackgroundType].imageUrl)
        : undefined, [themeBackgroundType]);
    const getContents = useCallback(() => {
        if (stageDimensionsW === undefined || stageDimensionsH === undefined || !texture || !themeBackgroundType) {
            return null;
        }
        const themeBackgroundProperties = ALL_THEME_BACKGROUND_PROPERTIES[themeBackgroundType];
        switch (themeBackgroundProperties.renderType) {
            case 'tile': {
                if (isConfigFlagEnabled('animatedRoomBackgroundsAvailable') && isAnimatedRoomBackgroundsOn) {
                    return (_jsx(PokerRoomAnimatedBackground, { texture: texture, textureDimensions: themeBackgroundProperties.dimensions, stageDimensionsW: stageDimensionsW, stageDimensionsH: stageDimensionsH }));
                }
                else {
                    return (_jsx(TilingSprite, { texture: texture, width: stageDimensionsW, height: stageDimensionsH, tilePosition: [0, 0] }));
                }
            }
            case 'cover': {
                return (_jsx(CoveringSprite, { texture: texture, textureW: themeBackgroundProperties.dimensions.w, textureH: themeBackgroundProperties.dimensions.h }));
            }
            default: {
                assertUnreachable(themeBackgroundProperties);
            }
        }
    }, [stageDimensionsH, stageDimensionsW, texture, themeBackgroundType, isAnimatedRoomBackgroundsOn]);
    if (stageDimensionsW === undefined || stageDimensionsH === undefined || !themeBackgroundType) {
        return null;
    }
    const contents = getContents();
    const pixiData = isTestEnvironment()
        ? {
            type: 'theme-background',
            themeBackgroundType
        }
        : null;
    const hasBackgroundVignette = ALL_THEME_BACKGROUND_PROPERTIES[themeBackgroundType].tableShadowAlpha !== 0;
    return (_jsxs(Container, { "pixi-data": pixiData, interactiveChildren: false, children: [contents, hasBackgroundVignette && (_jsx(CoveringSprite, { texture: PIXI.Texture.from(BACKGROUND_VIGNETTE_IMAGE_URL), textureW: 512, textureH: 512, alpha: 0.4 }))] }));
};
